/*!
 *для быстрой навигации с подсветкой
 */
 $(document).ready(function () {
  var positions = [],
    currentActive = null,
    links = $(".navrazd");

  $(".anchor").each(function () {
    positions.push({
      top: $(this).position().top - 100,
      a: links.filter('[href="#' + $(this).attr("id") + '"]'),
    });
  });

  positions = positions.reverse();

  var heightHeader = $(".header.navbar").outerHeight(true);
  $("#collapsibleNavbar").css("top", heightHeader + "px");
  $("#mainy .fixed-top").css("top", heightHeader + "px");

  $(window).on("scroll", function () {
    var scrolled = $(window).scrollTop();
    var heightStop =
      $(document).outerHeight(true) - $("footer").outerHeight(true) * 2.35;
    var heightHeader = $(".header.navbar").outerHeight(true);
    for (var i = 0; i < positions.length; i++) {
      if (positions[i].top < scrolled) {
        if (currentActive !== i) {
          currentActive = i;
          links.removeClass("active");
          positions[i].a.addClass("active");
        }
        break;
      }
    }

    if (positions[positions.length - 1].top + 100 > scrolled) {
      positions[positions.length - 1].a.removeClass("active");
    } else if (
      positions[positions.length - 1].top < scrolled &&
      positions[positions.length - 2].top > scrolled
    ) {
      positions[positions.length - 1].a.addClass("active");
    }

    if (scrolled >= 350 && scrolled < heightStop) {
      $(".sidenav").css("position", "fixed");
      $(".sidenav").css("top", "5%");
      // $(".sidenav .pdf_link").css("position","absolute");
      // $(".sidenav .pdf_link").css("bottom","-5px");
      // $(".sidenav .knopkho").css("top","100px");
      // $(".sidenav .knopkho").css("position","relative");
    } else if (scrolled < 350) {
      $(".sidenav").css("position", "relative");
      $(".sidenav").css("top", "60px");
      // $(".sidenav .pdf_link").css("position","relative");
      // $(".sidenav .pdf_link").css("bottom","-5px");
      // $(".sidenav .knopkho").css("top","0px");
      // $(".sidenav .knopkho").css("position","relative");
    } else {
      $(".sidenav").css("position", "relative");
    }

    if (scrolled >= heightHeader) {
      $("#collapsibleNavbar").removeClass("show");
      $("#collapsibleNavbar").css("top", "0px");
      $("#mainy .fixed-top").css("top", "10px");
      $("#mainy .navbar-toggler").addClass("collapsed");
      $("#mainy .navbar-toggler").css("background-color", "#ffffff");
      $("#mainy .navbar-toggler").attr("aria-expanded", "false");
    } else {
      $("#collapsibleNavbar").css("top", heightHeader + "px");
      $("#mainy .fixed-top").css("top", heightHeader + "px");
      $("#mainy .navbar-toggler").css("background-color", "transparent");
    }
  })
});
